import { useState, useEffect, useRef } from 'react';
import api from '../api';

// Satır satır not düzenleyici + kayıtlı notlar. Notlar tek metinde satır sonlarıyla tutulur.
// kind: "quote" | "hakedis" — teklif ve hakediş kayıtlı notları ayrı listelerdir.
export default function NotesEditor({ value, onChange, kind }) {
  const [focusNote, setFocusNote] = useState(null);
  const noteRefs = useRef([]);
  const [savedNotes, setSavedNotes] = useState([]);

  useEffect(() => {
    api.get(`/api/saved-notes/?kind=${kind}`).then(res => setSavedNotes(res.data)).catch(() => setSavedNotes([]));
  }, [kind]);

  // Yeni eklenen not satırına odaklan
  useEffect(() => {
    if (focusNote === null) return;
    noteRefs.current[focusNote]?.focus();
    setFocusNote(null);
  }, [focusNote]);

  const noteList = (value || '').split('\n');
  const setNotes = (list) => onChange(list.join('\n'));
  const updateNote = (index, text) => setNotes(noteList.map((n, i) => (i === index ? text : n)));
  const addNote = (index) => {
    setNotes([...noteList.slice(0, index), '', ...noteList.slice(index)]);
    setFocusNote(index);
  };
  const removeNote = (index) => setNotes(noteList.filter((_, i) => i !== index));

  const savedNoteFor = (text) => savedNotes.find(n => n.text === text.trim());
  const toggleSavedNote = async (text) => {
    const saved = savedNoteFor(text);
    try {
      if (saved) {
        await api.delete(`/api/saved-notes/${saved.id}`);
        setSavedNotes(savedNotes.filter(n => n.id !== saved.id));
      } else {
        const res = await api.post('/api/saved-notes/', { text, kind });
        setSavedNotes([...savedNotes, res.data]);
      }
    } catch (err) {
      alert('Hata: ' + (err.response?.data?.detail || 'Not kaydedilemedi'));
    }
  };
  const deleteSavedNote = async (note) => {
    if (!window.confirm(`"${note.text}" kayıtlı notlardan kaldırılsın mı?`)) return;
    try {
      await api.delete(`/api/saved-notes/${note.id}`);
      setSavedNotes(savedNotes.filter(n => n.id !== note.id));
    } catch (err) {
      alert('Hata: ' + (err.response?.data?.detail || 'Not silinemedi'));
    }
  };
  // Kayıtlı notları ekler; boş not satırları yerine yazılır
  const insertSavedNotes = (texts) => setNotes([...noteList.filter(n => n.trim()), ...texts]);
  const unusedSavedNotes = savedNotes.filter(n => !noteList.some(note => note.trim() === n.text));
  const docName = kind === 'hakedis' ? 'hakedişlerde' : 'tekliflerde';

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Notlar</label>
      <div className="space-y-2">
        {noteList.map((note, i) => (
          <div key={i} className="flex items-center gap-2">
            <span className="text-red-600 text-sm">•</span>
            <input value={note} ref={el => { noteRefs.current[i] = el; }}
              onChange={e => updateNote(i, e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addNote(i + 1); } }}
              placeholder={i === 0 ? 'Örn. Fiyatlarımıza KDV dahil değildir.' : ''}
              className="flex-1 border rounded px-3 py-2" />
            {note.trim() && (
              <button type="button" onClick={() => toggleSavedNote(note)}
                title={savedNoteFor(note) ? 'Kayıtlı notlardan kaldır' : `Notu kaydet (diğer ${docName} de kullanılabilir)`}
                className={`self-stretch text-sm font-medium px-3 rounded border whitespace-nowrap ${savedNoteFor(note)
                  ? 'bg-amber-50 text-amber-700 border-amber-300 hover:bg-amber-100'
                  : 'bg-white text-gray-500 border-gray-200 hover:bg-gray-50 hover:text-gray-700'}`}>
                {savedNoteFor(note) ? 'Kayıtlı' : 'Kaydet'}
              </button>
            )}
            {noteList.length > 1 && (
              <button type="button" onClick={() => removeNote(i)} className="text-red-500 hover:text-red-700 font-bold text-lg px-1" title="Notu sil">×</button>
            )}
          </div>
        ))}
      </div>
      <button type="button" onClick={() => addNote(noteList.length)} className="mt-2 text-sm text-blue-600 hover:text-blue-800 font-medium">+ Not Ekle</button>
      {unusedSavedNotes.length > 0 && (
        <div className="mt-3 border rounded-lg bg-gray-50 p-3">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-medium text-gray-600">Kayıtlı Notlar — eklemek için tıklayın</span>
            <button type="button" onClick={() => insertSavedNotes(unusedSavedNotes.map(n => n.text))}
              className="text-xs text-blue-600 hover:text-blue-800 font-medium">Tümünü Ekle</button>
          </div>
          <div className="space-y-1">
            {unusedSavedNotes.map(n => (
              <div key={n.id} className="flex items-center gap-2">
                <button type="button" onClick={() => insertSavedNotes([n.text])}
                  className="flex-1 text-left text-sm text-gray-700 bg-white border border-gray-200 rounded px-3 py-1.5 hover:border-blue-300 hover:bg-blue-50">
                  ↑ {n.text}
                </button>
                <button type="button" onClick={() => deleteSavedNote(n)} title="Kayıtlı notlardan kaldır"
                  className="text-gray-400 hover:text-red-600 font-bold text-lg px-1">×</button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
